import { useLocation } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { routesPath } from '../../common/constants/routesPath';
import { TOKEN, REFRESH_TOKEN } from '../../common/constants/localStorage';
import { getToken } from '../../services/tokenService';
import { HANDOFF_PATH, isImpersonationTab } from '../../services/impersonationSession';

function AuthGuard({ children }) {
    const location = useLocation();
    const isAuth = location.pathname.split('/')[1] === 'auth';
    const impersonating = isImpersonationTab();
    // an impersonation session has no refresh token; tokenService reads it from this tab's sessionStorage
    const signedIn = impersonating ? !!getToken(TOKEN) : !!(getToken(TOKEN) && getToken(REFRESH_TOKEN));

    if (isAuth) {
        return signedIn ? <Navigate to={routesPath.ROOT.JOBS} /> : children;
    }
    if (impersonating && !signedIn) {
        return <Navigate to={HANDOFF_PATH} />;
    }
    return signedIn ? children : <Navigate to={'auth/sign-in'} />;
}

export default AuthGuard;
